import React, { useMemo } from 'react';

import { getIn } from 'formik';
import { FormikValues } from 'formik/dist/types';

import { getFormikValue } from '../../../../utils/forms/formikFunctions';
import AppSelectWrapper, {
  IAppSelectWrapper,
} from '../../textfields/app-select-wrapper/AppSelectWrapper';

interface IFormSelectWrapper extends IAppSelectWrapper {
  formik: FormikValues | undefined;
  fieldName?: string;
}

const AppFormSelectWrapper: React.FC<IFormSelectWrapper> = ({
  formik,
  name,
  onChange,
  ...props
}) => {
  const formikValue = useMemo(
    () => getFormikValue(getIn(formik?.values, name)),
    [formik?.values, name],
  );

  return (
    <AppSelectWrapper
      name={name}
      defaultValue={formikValue}
      onBlur={formik?.handleBlur}
      error={getIn(formik?.touched, name) && !!getIn(formik?.errors, name)}
      onClearCallback={() => onChange(null)}
      helperText={
        <>
          {getIn(formik?.touched, name) &&
          typeof getIn(formik?.errors, name) === 'string'
            ? getIn(formik?.errors, name)
            : !!getIn(formik?.errors, name)}
        </>
      }
      onChange={(d: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
          onChange(d);
        } else {
          formik?.setFieldValue(name, d?.target?.value || null);
        }
      }}
      {...props}
    />
  );
};

export default AppFormSelectWrapper;
